export default {
  name: 'ChevronSelectorVerticalIcon',
  props: {
    color: {
      type: String,
      default: '#D1D1D1'
    },
    width: {
      type: String,
      default: '12'
    },
    height: {
      type: String,
      default: '12'
    }
  }
};